import Select from "react-select";
import "./style.css";
const ReactSelect = ({
  options,
  handleChange,
  disabled,
  error,
  defaultValue,
}) => {
  /*
    Options: array of objects [{value:"",label:""}]
    handleChange: handle select value change 
    disabled:form disabled
    error: boolean red borders 
   */

  return (
    <div
      className={`${
        error === false
          ? "custom-select-container"
          : "custom-select-container-error"
      }`}
    >
      <Select
        onChange={(event) => {
          handleChange(event.value, event.label);
        }}
        // menuIsOpen={true}
        isDisabled={disabled}
        className="custom-select-styling"
        options={options}
        defaultValue={defaultValue || options[0]}
      />
    </div>
  );
};

export default ReactSelect;
